import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Switch from 'react-switch';
import {TextArea} from '@react-ui-org/react-ui';
import Tooltip from '@mui/material/Tooltip';
import {makeStyles} from '@material-ui/core/styles';
import Dropdown from 'react-dropdown';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {ModalesUbicacion} from '../RegistroEmpresas/ModalesUbicacion';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {animateScroll as scroll} from 'react-scroll';
import {codigoPostalErroneo} from '../../fuctions/validacionFormularios';

export const FormularioSede = (props) => {
	const {index, setPantallaCrear, empresa, Usuario, get_sedes, sedeModificar, isMostrar, isLoad} =
		props;

	const [ModalErrores, setModalErrores] = useState(false);
	const [ModalUbiacion, setModalUbiacion] = useState(false);
	// const [latitud, setLatitud] = useState(sedeModificar.lat);
	// const [longitud, setLongitud] = useState(sedeModificar.lng);
	const [latitud, setLatitud] = useState('38.68233100180922');
	const [longitud, setLongitud] = useState('-6.405019122079416');
	const [Ubicacion, setUbicacion] = useState({
		lat: 38.68233100180922,
		lng: -6.405019122079416,
		// lat: latitud,
		// lng: longitud,
	});
	const [RadioUbicacion, setRadioUbicacion] = useState(3000);

	const [ListaProvincias, setListaProvincias] = useState([]);
	const [Provincia, setProvincia] = useState(0);
	const [ListaLocalidades, setListaLocalidades] = useState(['']);

	const [listaErrores, setListadeErrores] = useState([]);

	const [sede, setSede] = useState({
		sedesEmpresa: [
			{
				alias: sedeModificar.nombreSede,
				radio: sedeModificar.radio,
				codigoPostal: sedeModificar.codigoPostal,
				direccion: sedeModificar.direccion,
				localidad: sedeModificar.localidad,
				lat: sedeModificar.lat,
				lon: sedeModificar.lng,
			},
		],
		prestadorServicios: empresa.id,
		id: sedeModificar.id,
	});

	useEffect(()=>{
		if (sedeModificar.lat && sedeModificar.lng) {
			setLatitud(sedeModificar.lat);
			setLongitud(sedeModificar.lng);
			setUbicacion({lat:sedeModificar.lat, lng: sedeModificar.lng})
		}
	},[])

	const mapa = (lat, lng) => {
		setUbicacion({
			lat: lat,
			lng: lng,
		});
		console.log('ListadoSede', Ubicacion);
		setModalUbiacion(true);
	};

	const definirProvincias = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'provinciaAll/',
		}).then((response) => {
			setListaProvincias(response.data);
		});
	};

	const definirLocalidades = (id) => {
		if (id != '') {
			axios({
				method: 'get',
				url: window.ipdirection + 'localidadAll/?id_prov=' + id,
			}).then((response) => {
				let listaAxu = [];
				response.data.forEach((localidad) => {
					listaAxu.push({
						id: localidad.id,
						nombre: localidad.nombre,
						provincia: localidad.provincia,
					});
				});
				setListaLocalidades(listaAxu);
			});
		}
	};

	useEffect(() => {
		scroll.scrollTo(118);
		console.log(sedeModificar);
		definirProvincias();
		if (sedeModificar != '') {
			setUbicacion({
				lat: sedeModificar.lat,
				lng: sedeModificar.lng,
			});
			setRadioUbicacion(sedeModificar.radio);
		}
	}, []);

	useEffect(() => {
		definirLocalidades(Provincia);
	}, [Provincia]);

	useEffect(() => {
		setSede({
			...sede,
			sedesEmpresa: [
				{
					...sede.sedesEmpresa[0],
					lat: latitud,
					lon: longitud,
					radio: RadioUbicacion,
				},
			],
		});
	}, [latitud, longitud, RadioUbicacion]);

	const onInputChange = (event) => {
		console.log('event ', event.target.value);
		setSede({
			...sede,
			sedesEmpresa: [
				{
					...sede.sedesEmpresa[0],
					[event.target.name]: event.target.value,
				},
			],
		});
	};

	const guardarCambios = () => {
		if (sedeModificar.id === undefined) {
			anadirSede();
		} else {
			modificarSede();
		}
	};

	const anadirSede = () => {
		let data = sede;
		axios({
			method: 'post',
			url: window.ipdirection + 'sedePrestador_Cliente/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		}).then((response) => {
			setPantallaCrear(false);
			get_sedes();
		});
	};

	const modificarSede = () => {
		let data = sede;
		axios({
			method: 'put',
			url: window.ipdirection + 'sedePrestador_Cliente/' + sede.id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		}).then((response) => {
			setPantallaCrear(false);
			get_sedes();
		});
	};

	const validaciones = () => {
		if (sede.sedesEmpresa[0]['alias'] === undefined || sede.sedesEmpresa[0]['alias'] === '') {
			if (!listaErrores.includes('El nombre de la sede no puede estar vacio'))
				listaErrores.push('El nombre de la sede no puede estar vacio');
		} else {
			if (listaErrores.includes('El nombre de la sede no puede estar vacio'))
				listaErrores.splice('El nombre de la sede no puede estar vacio');
		}

		if (Provincia === undefined || Provincia === '') {
			if (!listaErrores.includes('Debe seleccionar una provincia'))
				listaErrores.push('Debe seleccionar una provincia');
		} else {
			if (listaErrores.includes('Debe seleccionar una provincia'))
				listaErrores.splice('Debe seleccionar una provincia');
		}

		if (
			sede.sedesEmpresa[0]['localidad'] === undefined ||
			sede.sedesEmpresa[0]['localidad'] === ''
		) {
			if (!listaErrores.includes('Debe seleccionar una localidad'))
				listaErrores.push('Debe seleccionar una localidad');
		} else {
			if (listaErrores.includes('Debe seleccionar una localidad'))
				listaErrores.splice('Debe seleccionar una localidad');
		}

		if (
			sede.sedesEmpresa[0]['codigoPostal'] === undefined ||
			sede.sedesEmpresa[0]['codigoPostal'] === ''
		) {
			if (!listaErrores.includes('El código postal no puede estar vacio'))
				listaErrores.push('El código postal no puede estar vacio');
		} else {
			if (listaErrores.includes('El código postal no puede estar vacio'))
				listaErrores.splice('El código postal no puede estar vacio');
		}

		if (
			sede.sedesEmpresa[0]['direccion'] === undefined ||
			sede.sedesEmpresa[0]['direccion'] === ''
		) {
			if (!listaErrores.includes('La dirección no puede estar vacia'))
				listaErrores.push('La dirección no puede estar vacia');
		} else {
			if (listaErrores.includes('La dirección no puede estar vacia'))
				listaErrores.splice('La dirección no puede estar vacia');
		}

		if (
			sede.sedesEmpresa[0]['lat'] === undefined ||
			sede.sedesEmpresa[0]['lat'] === '' ||
			sede.sedesEmpresa[0]['lon'] === undefined ||
			sede.sedesEmpresa[0]['lon'] === ''
		) {
			if (!listaErrores.includes('Debe seleccionar una ubicación'))
				listaErrores.push('Debe seleccionar una ubicación');
		} else {
			if (listaErrores.includes('Debe seleccionar una ubicación'))
				listaErrores.splice('Debe seleccionar una ubicación');
		}

		if (listaErrores.length === 0) {
			guardarCambios();
			listaErrores.splice(0, listaErrores.length);
		} else {
			setModalErrores(true);
		}
	};

	return (
		<div className='ContentBodyMiPerfil'>
			<div className='miPerfilInferior'>
				<div className='datoFormularioUsuarioRegistro'>
					<div className='label-formulario-registro'>
						<div>
							<b>Alias</b>
						</div>
						<div>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='10'
								height='10'
								fill='currentColor'
								class='bi bi-asterisk'
								viewBox='0 0 16 16'
							>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
							</svg>
						</div>
					</div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Alias de la sede'}
						onChange={(event) => onInputChange(event)}
						value={sede.sedesEmpresa[0]['alias']}
						name='alias'
						Id={'alias '}
					/>
				</div>
				<div className='datoFormularioUsuarioRegistro'>
					<div className='label-formulario-registro'>
						<div>
							<b>Provincia</b>
						</div>
						<div>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='10'
								height='10'
								fill='currentColor'
								class='bi bi-asterisk'
								viewBox='0 0 16 16'
							>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
							</svg>
						</div>
					</div>
					<Select
						className='inputTextUsuario inputDrop'
						id='provincia'
						name='provincia'
						placeholder={'--Seleccionar--'}
						onChange={(event) => setProvincia(event.target.value, index)}
					>
						{ListaProvincias.map((provincia, index) => (
							<MenuItem
								value={provincia.id}
								key={index}
								selected
							>
								{provincia.nombre}{' '}
							</MenuItem>
						))}
					</Select>
				</div>
				<div className='datoFormularioUsuarioRegistro'>
					<div className='label-formulario-registro'>
						<div>
							<b>Localidad</b>
						</div>
						<div>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='10'
								height='10'
								fill='currentColor'
								class='bi bi-asterisk'
								viewBox='0 0 16 16'
							>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
							</svg>
						</div>
					</div>

					<Select
						className='inputTextUsuario inputDrop'
						id='localidad'
						name='localidad'
						placeholder={'--Seleccionar--'}
						onChange={(event) => onInputChange(event)}
					>
						{ListaLocalidades.map((localidad, index) => (
							<MenuItem
								value={localidad.nombre}
								key={index}
							>
								{localidad.nombre}
							</MenuItem>
						))}
					</Select>
				</div>

				<div className='datoFormularioUsuarioRegistro'>
					<div className='label-formulario-registro'>
						<div>
							<b>Código postal</b>
						</div>
						<div>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='10'
								height='10'
								fill='currentColor'
								class='bi bi-asterisk'
								viewBox='0 0 16 16'
							>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
							</svg>
						</div>
					</div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'10003'}
						onChange={(event) => onInputChange(event)}
						value={sede.sedesEmpresa[0]['codigoPostal']}
						name='codigoPostal'
						Id={'codigoPostal'}
					/>
				</div>
				<div className='datoFormularioUsuarioRegistro'>
					<div className='label-formulario-registro'>
						<div>
							<b>Dirección</b>
						</div>
						<div>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='10'
								height='10'
								fill='currentColor'
								class='bi bi-asterisk'
								viewBox='0 0 16 16'
							>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
							</svg>
						</div>
					</div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'C/ Cosechas 12 1B'}
						onChange={(event) => onInputChange(event)}
						value={sede.sedesEmpresa[0]['direccion']}
						name='direccion'
						Id={'direccion'}
					/>
				</div>
				<div className='centrador-button-ubicacion'>
					<div
						className='buttonBuscar'
						onClick={() => {
							//setSeleccionUbicacion(true);
							{
								isLoad != '' || isLoad != true
									? mapa(sedeModificar.lat, sedeModificar.lng)
									: mapa(Ubicacion.lat, Ubicacion.lng);
							}
							//console.log("llega", Ubicacion, SeleccionUbicacion)
						}}
					>
						<div className='centrador'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='16'
								height='16'
								fill='currentColor'
								class='bi bi-geo-alt'
								viewBox='0 0 16 16'
							>
								<path d='M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z' />
								<path d='M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z' />
							</svg>
						</div>
						<div>
							<b>Seleccionar ubicación</b>
						</div>
					</div>
				</div>
				<div className='separador' />
				<div className='buttonsMiPerfil'>
					<div
						className='button borrarCuenta'
						onClick={() => setPantallaCrear(false)}
					>
						<b>Cancelar</b>
					</div>
					<div
						className='button'
						onClick={() => validaciones()}
					>
						<b>Guardar</b>
					</div>
				</div>
				<ModalesUbicacion
					ModalUbiacion={ModalUbiacion}
					setModalUbiacion={setModalUbiacion}
					Ubicacion={Ubicacion}
					setUbicacion={setUbicacion}
					RadioUbicacion={RadioUbicacion}
					setRadioUbicacion={setRadioUbicacion}
					setLatitud={setLatitud}
					setLongitud={setLongitud}
					isMostrar={isMostrar}
					isLoad={isLoad}
				/>

				<Modal
					centered={true}
					isOpen={ModalErrores}
				>
					<ModalHeader>
						<div className='titulo-modal'>Datos de la sede erróneos</div>
					</ModalHeader>
					<ModalBody>
						<div>
							{' '}
							{listaErrores.map((error) => (
								<div className='descripcion-servicio descripcion-modal'>
									{' '}
									- {error}{' '}
								</div>
							))}{' '}
						</div>
					</ModalBody>
					<ModalFooter>
						<div className='centrador'>
							<div
								className='button'
								onClick={() => setModalErrores(false)}
							>
								<b>Aceptar</b>
							</div>
						</div>
					</ModalFooter>
				</Modal>
			</div>
		</div>
	);
};
